export enum ImageTypeEnum {
    PRODUCT = 'product',
    SPHERE = 'sphere',
    CARD = 'card',
    PERSONAGE = 'personage',
    TOON_TINT_CATEGORY = 'toon-tint-category',
    TOON_TINT_CATEGORY_ITEM = 'toon-tint-category-item',
}
